import $$ from 'dom7';
import Framework7 from 'framework7';
import URLS from '../js/Urls.js';
import { ok } from 'assert';
import { async } from 'q';
import { translateKey } from 'reword-js';
import _ from 'lodash';
var moment = require('moment');
var today = new Date();

var Dashboardinfo = {};
var AllReservations = {};
var Reservations = {};
var Cancellations = {};
var ALLReservationsByDate = {};
var ReservationsByDate = {};
var CancellationsByDate = {};
var Roomscategories = {};

var ReservationPlanData = {};
var Availabilities = {};

// Show Preloader

var actions = {
    SaveAvailabilityParams: function (FromDate, Todate, RoomCatID) {
        var result = Roomscategories.filter((room) => room.RoomCategoryID == RoomCatID);

        var obj = {
            FromDate: FromDate,
            Todate: Todate,
            RoomCatID: RoomCatID,
            RoomCatDesc: result[0].RoomCategoryTitleDefault,
        };
        Availabilities = obj;
        //localStorage.setItem('Availabilities',JSON.stringify(obj));
    },

    GetAvailabilityParams() {
        //return JSON.parse(localStorage.getItem('Availabilities'));
        return Availabilities;
    },
    LoginAsProperty: async function (propertyID, propertyname, userID, UserSpecificApiKey) {
        app.f7.preloader.show();
        var login = JSON.parse(localStorage.getItem('loginJson'));
        login.PropertyID = propertyID;
        login.PropertyName = propertyname;
        login.UserID = userID;
        localStorage.setItem('loginJson', JSON.stringify(login));

        var MyDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        //app.f7.views.main.router.navigate('/main/');
        var obj = {
            PropertyID: propertyID,
            Date: MyDate,
            UserID: login.UserID,
            UserSpecificApiKey: UserSpecificApiKey,
        };
        if (login?.IsHousekeeper === false) {
            await actions.GetDashboardData(obj);
        }

        app.f7.preloader.hide();
        //app.f7.views.main.router.refreshPage(); //kanw refresh to page
    },
    resetCustomerSearch: function () {
        localStorage.removeItem('searchCustomer');
    },
    setCustomerSearch: function (customer) {
        localStorage.setItem('searchCustomer', JSON.stringify(customer));
    },
    addToCart: function (room) {
        var loginObject = JSON.parse(localStorage.getItem('loginJson'));
        var cart = JSON.parse(localStorage.getItem('cart'));
        if (!cart?.propertyID) {
            cart = {
                propertyID: loginObject.PropertyID,
                userID: loginObject.UserID,
                dateCreated: new Date(),
                totalRooms: 0,
                totalPrice: 0,
                rooms: [],
            };
        }
        const existingRoomIndex = cart.rooms.findIndex(
            (cartRoom) =>
                cartRoom.roomCategoryID === room.roomCategoryID &&
                cartRoom.dates.RoomDateFrom === room.dates.RoomDateFrom &&
                cartRoom.dates.RoomDateTo === room.dates.RoomDateTo
        );
        if (existingRoomIndex !== -1) {
            // If room exists, update it
            const existingRoom = cart.rooms[existingRoomIndex];
            existingRoom.price += room.price;
            existingRoom.numberOfRooms++;
            cart.totalPrice += room.price;
            cart.totalRooms++;
        } else {
            // If room doesn't exist, add it to the cart
            room.numberOfRooms = 1; // Initialize numberOfRooms
            cart.totalRooms++;
            cart.totalPrice += room.price;
            cart.rooms.push(room);
        }

        localStorage.setItem('cart', JSON.stringify(cart));
    },
    removeFromCart: function (roomCategoryID) {
        var cart = JSON.parse(localStorage.getItem('cart'));
        const index = cart.rooms.findIndex((cartRoom) => cartRoom.roomCategoryID === roomCategoryID);
        if (index !== -1) {
            const removedRoom = cart.rooms.splice(index, 1)[0];
            if (cart.rooms.length === 0) {
                var cart = JSON.parse(localStorage.getItem('cart'));
                cart.userID = null;
                cart.dateCreated = null;
                cart.propertyID = null;
                cart.totalRooms = 0;
                cart.totalPrice = 0;
                cart.rooms = [];
            } else {
                cart.totalRooms--;
                cart.totalPrice -= removedRoom.price;
            }
        }
        localStorage.setItem('cart', JSON.stringify(cart));
    },
    clearCart: function () {
        var cart = JSON.parse(localStorage.getItem('cart'));
        cart.userID = null;
        cart.dateCreated = null;
        cart.propertyID = null;
        cart.totalRooms = 0;
        cart.totalPrice = 0;
        cart.rooms = [];

        localStorage.setItem('cart', JSON.stringify(cart));
    },
    LoginSetResult: function (obj) {
        localStorage.setItem('loginJson', JSON.stringify(obj));
        localStorage.setItem('planDisplaySwitch', JSON.stringify(obj.PlanDisplaySwitch));
        localStorage.setItem('planUnassigned', JSON.stringify(obj.PlanUnassigned));
        localStorage.setItem('userCurrency', JSON.stringify(obj.Currency));
    },
    LoginGetResult: function () {
        // var login = JSON.parse(localStorage.getItem('loginJson'));
        return JSON.parse(localStorage.getItem('loginJson'));
    },
    GetUserCurrency: function () {
        return JSON.parse(localStorage.getItem('userCurrency'));
    },

    GetPropertyName: function () {
        var login = JSON.parse(localStorage.getItem('loginJson'));
        return login?.PropertyName;
    },
    GetNews: async function () {
        var News;
        await app.f7.request.promise.post(URLS.getnews, {}).then((res) => {
            app.f7.preloader.hide();
            News = JSON.parse(res.data);
        });
        return News;
    },
    GetNotificationsCounter: async function (UserSpecificApiKey) {
        var login = JSON.parse(localStorage.getItem('loginJson'));
        var counter = 0;
        var obj = {
            PropertyID: login?.PropertyID,
            UserID: login?.UserID,
            UserSpecificApiKey: UserSpecificApiKey,
        };
        await app.f7.request.promise
            .post(URLS.getnotificationcounter, { obj })

            .then((res) => {
                app.f7.preloader.hide();
                counter = JSON.parse(res.data);
            });

        return counter;
    },

    SetDashboardInfo: function (obj) {
        if (obj == 'Error') {
            return (Dashboardinfo = {});
        }
        Dashboardinfo = obj;

        Dashboardinfo.Arrivals = {};
        Dashboardinfo.Arrivals.CheckIn = obj?.CheckinsTodayList?.filter((e) => {
            return !e.IsCheckedIn;
        });
        Dashboardinfo.Arrivals.CheckedIn = obj?.CheckinsTodayList?.filter((e) => {
            return e.IsCheckedIn;
        });

        Dashboardinfo.Departures = {};
        Dashboardinfo.Departures.CheckOut = obj?.CheckoutsTodayList?.filter((e) => {
            return !e.IsCheckedOut;
        });
        Dashboardinfo.Departures.CheckedOut = obj?.CheckoutsTodayList?.filter((e) => {
            return e.IsCheckedOut;
        });

        Dashboardinfo.Inhouse = {};
        Dashboardinfo.Inhouse.Available = obj?.InhouseTodayList?.filter((e) => {
            return !e.isInHouse;
        });
        Dashboardinfo.Inhouse.Inhouse = obj?.InhouseTodayList?.filter((e) => {
            return e.isInHouse;
        });
    },

    GETNotificationSettings: async function () {
        var login = JSON.parse(localStorage.getItem('loginJson'));
        var set = 0;
        var obj = {
            UserID: login.UserID,
        };
        await app.f7.request.promise.get(URLS.SetNotificationSettings, { UserID: login.UserID }).then((res) => {
            app.f7.preloader.hide();
            set = JSON.parse(res.data);
        });
        return set;
    },

    SetReservations: function (obj) {
        AllReservations = obj;
        ALLReservationsByDate = _.chain(AllReservations)
            // Group the elements of Array based on `color` property
            .groupBy('ReservationBookingDayStr')
            // `key` is group's name (color), `value` is the array of objects
            .map((value, key) => ({
                ReservationBookingDayStr: key,
                Reservations: value,
            }))
            .value();

        Cancellations = AllReservations.filter(function (el) {
            return el.IsCancellation == true;
        });

        Reservations = AllReservations.filter(function (el) {
            return el.IsCancellation == false;
        });

        ReservationsByDate = _.chain(Reservations)
            // Group the elements of Array based on `color` property
            .groupBy('ReservationBookingDayStr')
            // `key` is group's name (color), `value` is the array of objects
            .map((value, key) => ({
                ReservationBookingDayStr: key,
                Reservations: value,
            }))
            .value();

        CancellationsByDate = _.chain(Cancellations)
            // Group the elements of Array based on `color` property
            .groupBy('ReservationBookingDayStr')
            // `key` is group's name (color), `value` is the array of objects
            .map((value, key) => ({
                ReservationBookingDayStr: key,
                Reservations: value,
            }))
            .value();
    },

    GetDashboardinfo: function () {
        return Dashboardinfo;
    },

    //Get rooms categories
    GetRoomsCatinfo: function () {
        return Roomscategories;
    },

    AllReservationsGetResult: function () {
        return AllReservations;
    },
    ReservationsGetResult: function () {
        return Reservations;
    },

    CancellationsGetResult: function () {
        return CancellationsByDate;
    },
    GetAllReservationsGroupByDate: function () {
        return ALLReservationsByDate;
    },
    GetReservationsGroupByDate: function () {
        return ReservationsByDate;
    },
    GetRoomsCategoriers: async function () {
        var Loginobj = actions.LoginGetResult();
        var PropertyID = Loginobj?.PropertyID;
        let UserID = Loginobj?.UserID;
        app.f7.preloader.show();
        const UserSpecificApiKey = Loginobj?.PropertiesList?.find((property) => property.PropertyName == Loginobj?.PropertyName)?.UserSpecificApiKey;
        await app.f7.request.promise.post(URLS.roomscategories, { PropertyID, UserID, UserSpecificApiKey }).then((res) => {
            app.f7.preloader.hide();
            var RoomsCat = JSON.parse(res.data);
            RoomsCat = RoomsCat.filter((room) => room.IsPayMaster == false);
            Roomscategories = RoomsCat;
        });
        app.f7.preloader.hide();
    },
    GetReservationRooms: async function (FromDate, ToDate, rooms, Adults, Children, RoomID, RoomTypeID, UserSpecificApiKey) {
        var Loginobj = actions.LoginGetResult();
        var fromstr = moment(FromDate).format('YYYY-MM-DD');
        var tostr = moment(ToDate).format('YYYY-MM-DD');
        var RoomsList = {};
        var PropertyID = Loginobj?.PropertyID;
        var obj = {
            FromDate: fromstr,
            ToDate: tostr,
            PropertyID: PropertyID,
            UserID: Loginobj?.UserID,
            Rooms: rooms,
            Adults: Adults,
            Children: Children,
            RoomID: RoomID,
            RoomTypeID: RoomTypeID,
            UserSpecificApiKey: UserSpecificApiKey,
        };
        app.f7.preloader.show();

        await app.f7.request.promise.post(URLS.GetReservationRooms, { obj }).then((res) => {
            app.f7.preloader.hide();
            RoomsList = JSON.parse(res.data);
        });
        app.f7.preloader.hide();
        return RoomsList;
    },
    GetPropertySources: async function (PropertyID) {
        var Sources = {};
        var obj = {
            PropertyID: PropertyID,
        };
        app.f7.preloader.show();

        await app.f7.request.promise.post(URLS.GetPropertySources, { obj }).then((res) => {
            app.f7.preloader.hide();
            Sources = JSON.parse(res.data);
        });
        app.f7.preloader.hide();
        return Sources;
    },
    GetKeeperRooms: async function (selectedDate) {
        var Loginobj = actions.LoginGetResult();
        var date = moment(selectedDate).format('YYYY-MM-DD');
        var RoomsList = {};
        var PropertyID = Loginobj?.PropertyID;
        var obj = {
            PropertyID: PropertyID,
            UserID: Loginobj?.UserID,
            CheckDate: date,
        };
        app.f7.preloader.show();

        await app.f7.request.promise
            .post(URLS.GetKeeperRooms, { obj })

            .then((res) => {
                app.f7.preloader.hide();
                RoomsList = JSON.parse(res.data);
            });

        app.f7.preloader.hide();
        return RoomsList;
    },

    GetHousekeepingRoomDetails: async function (propertyID, selectedDate, userID, roomID, reservationID) {
        let roomDetails;
        let obj = {
            PropertyID: propertyID,
            CheckDate: selectedDate,
            UserID: userID,
            RoomID: roomID,
            ReservationID: reservationID,
        };
        app.f7.preloader.show();

        await app.f7.request.promise
            .post(URLS.GetHousekeepingRoomDetails, { obj })

            .then((res) => {
                app.f7.preloader.hide();
                roomDetails = JSON.parse(res.data);
            });

        app.f7.preloader.hide();
        return roomDetails;
    },
    GetHousekeepingRoomStatus: async function (propertyID, selectedDate, userID, roomID) {
        let roomDetails;
        let obj = {
            PropertyID: propertyID,
            CheckDate: selectedDate,
            UserID: userID,
            RoomID: roomID,
        };
        app.f7.preloader.show();
        await app.f7.request.promise.post(URLS.GetHousekeepingRoomStatus, { obj }).then((res) => {
            roomDetails = JSON.parse(res.data);
        });

        app.f7.preloader.hide();
        return roomDetails;
    },

    GetHousekeepingNotes: async function (propertyID, selectedDate, userID, roomID, reservationID) {
        let roomDetails;
        let obj = {
            PropertyID: propertyID,
            CheckDate: selectedDate,
            UserID: userID,
            RoomID: roomID,
            ReservationID: reservationID,
        };
        app.f7.preloader.show();

        await app.f7.request.promise
            .post(URLS.GetHousekeepingNotes, { obj })

            .then((res) => {
                app.f7.preloader.hide();
                roomDetails = JSON.parse(res.data);
            });

        app.f7.preloader.hide();
        return roomDetails;
    },

    StartWork: async function (propertyID, userID, roomID, date) {
        let obj = {
            PropertyID: propertyID,
            CheckDate: date,
            UserID: userID,
            RoomID: roomID,
        };
        app.f7.preloader.show();

        await app.f7.request.promise
            .post(URLS.StartWork, { obj })

            .then((res) => {
                app.f7.preloader.hide();
            });

        app.f7.preloader.hide();
    },

    EndWork: async function (propertyID, userID, roomID, date, status) {
        let obj = {
            PropertyID: propertyID,
            CheckDate: date,
            UserID: userID,
            RoomID: roomID,
            StatusID: status,
        };
        app.f7.preloader.show();

        await app.f7.request.promise
            .post(URLS.EndWork, { obj })

            .then((res) => {
                app.f7.preloader.hide();
            });

        app.f7.preloader.hide();
    },

    SubmitRoomProblem: async function (propertyID, userID, problemID, problemCategoryID, roomID, reportMessage, priotity) {
        let obj = {
            PropertyID: propertyID,
            UserID: userID,
            ProblemID: problemID,
            ProblemCategoryID: problemCategoryID,
            RoomID: roomID,
            Description: reportMessage,
            Priority: priotity,
        };
        app.f7.preloader.show();

        await app.f7.request.promise
            .post(URLS.SubmitRoomProblem, { obj })

            .then((res) => {
                app.f7.preloader.hide();
            });

        app.f7.preloader.hide();
    },

    SubmitRoomNote: async function (propertyID, userID, roomID, reservationID, noteID = '0', noteText, priotity = '') {
        let obj = {
            PropertyID: propertyID,
            UserID: userID,
            RoomID: roomID,
            ReservationID: reservationID,
            NoteID: noteID,
            NoteText: noteText,
            Priority: priotity,
        };
        app.f7.preloader.show();

        await app.f7.request.promise
            .post(URLS.SubmitRoomNote, { obj })

            .then((res) => {
                app.f7.preloader.hide();
            });

        app.f7.preloader.hide();
    },

    SubmitRoomStatus: async function (propertyID, userID, roomID, status, checkDate) {
        let obj = {
            PropertyID: propertyID,
            UserID: userID,
            RoomID: roomID,
            Status: status,
            CheckDate: checkDate,
        };
        app.f7.preloader.show();

        await app.f7.request.promise
            .post(URLS.SubmitRoomStatus, { obj })

            .then((res) => {
                app.f7.preloader.hide();
            });

        app.f7.preloader.hide();
    },

    ToggleDoNotDisturb: async function (propertyID, reservationID, checkboxStatus) {
        let obj = {
            PropertyID: propertyID,
            ReservationID: reservationID,
            DoNotDisturb: checkboxStatus,
        };
        let response;
        app.f7.preloader.show();

        await app.f7.request.promise
            .post(URLS.ToggleDoNotDisturb, { obj })

            .then((res) => {
                app.f7.preloader.hide();
                response = res;
            });

        app.f7.preloader.hide();
        return response;
    },

    GetHousekeepingRoomProblems: async function (propertyID, userID, roomID, checkDate) {
        let obj = {
            PropertyID: propertyID,
            UserID: userID,
            RoomID: roomID,
            CheckDate: checkDate,
        };
        let response;
        app.f7.preloader.show();

        await app.f7.request.promise
            .post(URLS.GetHousekeepingRoomProblems, { obj })

            .then((res) => {
                app.f7.preloader.hide();
                response = res;
            });

        app.f7.preloader.hide();
        return response;
    },

    GetInvoices: async function (FromDate, ToDate) {
        var Loginobj = actions.LoginGetResult();
        var Invoices = '';
        var PropertyID = Loginobj?.PropertyID;
        var UserID = Loginobj?.UserID;
        const UserSpecificApiKey = Loginobj?.PropertiesList?.find((property) => property.PropertyName == Loginobj?.PropertyName)?.UserSpecificApiKey;

        app.f7.preloader.show();
        var obj = {
            PropertyID: PropertyID,
            UserID: UserID,
            UserSpecificApiKey: UserSpecificApiKey,
        };
        await app.f7.request.promise
            .post(URLS.GetInvoices, { obj })

            .then((res) => {
                app.f7.preloader.hide();
                Invoices = JSON.parse(res.data);
                app.f7.preloader.hide();
            });
        return Invoices;
    },

    GetReservationsForPlan: async function (FromDate, ToDate) {
        var Loginobj = actions.LoginGetResult();

        var PropertyID = Loginobj?.PropertyID;
        var FromDate = new Date();
        var PlanData = {};
        var ToDate = new Date(FromDate.getFullYear(), FromDate.getMonth() + 1, 0);
        var startdate = new Date(FromDate.getFullYear(), FromDate.getMonth(), 1);
        var fromstr = moment(startdate).format('YYYY-MM-DD');
        var tostr = moment(ToDate).format('YYYY-MM-DD');
        app.f7.preloader.show();

        var obj = {
            DateFrom: fromstr,
            DateTo: tostr,
            PropertyID: PropertyID,
        };
        await app.f7.request.promise
            .post(URLS.OverviewPlan, { obj })

            .then((res) => {
                app.f7.preloader.hide();
                PlanData = JSON.parse(res.data);
            });

        return PlanData;
    },
    GetMonthlyResData: async function (date) {
        var toastCheckConnection = app.f7.toast.create({
            text: 'Error,check internet connection',
            position: 'center',
            closeTimeout: 1500,
        });
        let login = JSON.parse(localStorage.getItem('loginJson'));
        const UserSpecificApiKey = login?.PropertiesList?.find((property) => property.PropertyName == login?.PropertyName)?.UserSpecificApiKey;
        var MonthlyReservations;
        var obj = {
            Date: date,
            PropertyID: login.PropertyID,
            UserID: login.UserID,
            UserSpecificApiKey: UserSpecificApiKey,
        };
        app.f7.preloader.show();
        try {
            await app.f7.request.promise
                .post(URLS.monthlyres, { obj })

                .then((res) => {
                    MonthlyReservations = JSON.parse(res.data);
                    app.f7.preloader.hide();
                });
        } catch {
            app.f7.preloader.hide();
            toastCheckConnection.open();
        }
        return MonthlyReservations;
    },

    GetMonthlyAvailabilityData: async function (datefrom, dateto, tempRoomCatID) {
        var toastCheckConnection = app.f7.toast.create({
            text: 'Error,check internet connection',
            position: 'center',
            closeTimeout: 1500,
        });
        var startdate = new Date(datefrom.getFullYear(), datefrom.getMonth(), 1);
        var ToDate;
        if (dateto == null) {
            ToDate = new Date(datefrom.getFullYear(), datefrom.getMonth() + 1, 0);
        } else {
            ToDate = new Date(dateto.getFullYear(), dateto.getMonth() + 1, dateto.getDate());
        }
        var fromstr = moment(startdate).format('YYYY-MM-DD');
        var tostr = moment(ToDate).format('YYYY-MM-DD');
        var MonthlyAvailabilities;
        var Loginobj = actions.LoginGetResult();
        var obj = {
            FromDate: fromstr,
            ToDate: tostr,
            RoomCatID: tempRoomCatID,
            PropertyID: Loginobj.PropertyID,
        };
        app.f7.preloader.show();
        try {
            await app.f7.request.promise.post(URLS.GetAvailabilities, { obj }).then((res) => {
                MonthlyAvailabilities = JSON.parse(res.data);
                app.f7.preloader.hide();
            });
        } catch {
            app.f7.preloader.hide();
            toastCheckConnection.open();
        }
        return MonthlyAvailabilities;
    },
    GetAvailPriceData: async function (datefrom, dateto, tempRoomCatID) {
        var toastCheckConnection = app.f7.toast.create({
            text: 'Error,check internet connection',
            position: 'center',
            closeTimeout: 1500,
        });

        var startdate = new Date(datefrom.getFullYear(), datefrom.getMonth(), datefrom.getDate());

        var ToDate;
        if (dateto == null) {
            ToDate = startdate;
        } else {
            ToDate = new Date(dateto.getFullYear(), dateto.getMonth(), dateto.getDate());
        }

        var fromstr = moment(startdate).format('YYYY-MM-DD');
        var tostr = moment(ToDate).format('YYYY-MM-DD');

        var AvailabilityData;
        var Loginobj = actions.LoginGetResult();
        var obj = {
            FromDate: fromstr,
            ToDate: tostr,
            RoomCatID: tempRoomCatID,
            PropertyID: Loginobj.PropertyID,
        };
        app.f7.preloader.show();
        const currency = await this.GetUserCurrency();
        try {
            await app.f7.request.promise
                .post(URLS.GetPricePlanInfo, { obj })

                .then((res) => {
                    AvailabilityData = JSON.parse(res.data);

                    app.f7.preloader.hide();
                });
        } catch {
            app.f7.preloader.hide();
            toastCheckConnection.open();
        }

        AvailabilityData = AvailabilityData.map((item) => {
            const updatedItem = { ...item, Currency: currency };
            updatedItem.Prices = item.Prices.map((priceItem) => {
                return { ...priceItem, Currency: currency };
            });
            return updatedItem;
        });
        return AvailabilityData;
    },
    GetAvailabilityData: async function (datefrom, dateto, tempRoomCatID) {
        var toastCheckConnection = app.f7.toast.create({
            text: 'Error,check internet connection',
            position: 'center',
            closeTimeout: 1500,
        });

        var startdate = new Date(datefrom.getFullYear(), datefrom.getMonth(), datefrom.getDate());

        var ToDate;
        if (dateto == null) {
            ToDate = startdate;
        } else {
            ToDate = new Date(dateto.getFullYear(), dateto.getMonth(), dateto.getDate());
        }

        var fromstr = moment(startdate).format('YYYY-MM-DD');
        var tostr = moment(ToDate).format('YYYY-MM-DD');

        var AvailabilityData;
        var Loginobj = actions.LoginGetResult();
        var obj = {
            FromDate: fromstr,
            ToDate: tostr,
            RoomCatID: tempRoomCatID,
            PropertyID: Loginobj.PropertyID,
        };

        app.f7.preloader.show();
        try {
            await app.f7.request.promise.post(URLS.GetAvailabilityInfo, { obj }).then((res) => {
                AvailabilityData = JSON.parse(res.data);
                app.f7.preloader.hide();
            });
        } catch {
            app.f7.preloader.hide();
            toastCheckConnection.open();
        }
        return AvailabilityData;
    },
    GetDashboardData: async function (obj, forcelogin) {
        await app.f7.request.promise.post(URLS.dashboardinfo, { obj }).then((res) => {
            var DashboardinfoResponse = JSON.parse(res.data);
            actions.SetDashboardInfo(DashboardinfoResponse);
            if (forcelogin == true) {
                setTimeout(function () {
                    if (login.IsHouseKeeper === 1) {
                        app.f7.views.main.router.navigate('/dashboardKeeper/', {
                            transition: 'f7-dive',
                        });
                    } else {
                        app.f7.views.main.router.navigate('/main/', {
                            transition: 'f7-dive',
                        });
                    }
                }, 700);
            }
        });
    },
    ReadNotification: async function (noticationid, dismiss) {
        var Loginobj = actions.LoginGetResult();
        var obj = {
            NotificationID: noticationid,
            UserID: Loginobj?.UserID,
            Dismiss: dismiss,
        };
        await app.f7.request.promise.post(URLS.readnotification, { obj }).then((res) => {});
    },
    GetNotificationsData: async function () {
        var Notifications;
        var Loginobj = actions.LoginGetResult();
        const UserSpecificApiKey = Loginobj?.PropertiesList?.find((property) => property.PropertyName == Loginobj?.PropertyName)?.UserSpecificApiKey;
        var obj = {
            PropertyID: Loginobj.PropertyID,
            UserID: Loginobj?.UserID,
            UserSpecificApiKey: UserSpecificApiKey,
        };
        app.f7.preloader.show();

        await app.f7.request.promise.post(URLS.getnotifications, { obj }).then((res) => {
            Notifications = JSON.parse(res.data);
        });
        return Notifications;
    },
    GetReservationsData: async function (obj) {
        var Loginobj = actions.LoginGetResult();
        var obj = {
            PropertyID: Loginobj.PropertyID,
        };
        app.f7.preloader.show();

        await app.f7.request.promise
            .post(URLS.reservations, { obj })

            .then((res) => {
                app.f7.preloader.hide();
                var ReservationsResponse = JSON.parse(res.data);
                actions.SetReservations(ReservationsResponse);
            });
        app.f7.preloader.hide();
    },

    GetNewDashboardData: async function (minDate, maxDate) {
        var Loginobj = actions.LoginGetResult();
        // var obj = {
        //     PropertyID: Loginobj.PropertyID,
        //     UserID: Loginobj.UserID
        // };
        app.f7.preloader.show();

        await app.f7.request.promise
            .post(
                URLS.GetNewDashboardData +
                    '?PropertyID=' +
                    Loginobj?.PropertyID +
                    '&UserID=' +
                    Loginobj?.UserID +
                    '&from=' +
                    minDate +
                    '&to=' +
                    maxDate
            )
            .then((res) => {
                app.f7.preloader.hide();
                return res.data;
            });
        app.f7.preloader.hide();
    },

    GetDetails: function () {
        app.f7.preloader.show();
        setTimeout(function () {
            // We got user data from request
            var user = {
                firstName: 'Vladimir',
                lastName: 'Kharlampidi',
                about: 'Hello, i am creator of Framework7! Hope you like it!',
                links: [
                    {
                        title: 'Framework7 Website',
                        url: 'http://framework7.io',
                    },
                    {
                        title: 'Framework7 Forum',
                        url: 'http://forum.framework7.io',
                    },
                ],
            };
            // Hide Preloader
            app.f7.preloader.hide();
        }, 3000);
    },

    GetDetailsBeforePromise: function (router) {
        app.f7.preloader.show();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                resolve('anything');
                app.f7.preloader.hide();
            }, 5000);
        });
    },

    GetDetailsBefore: function (router) {
        app.f7.preloader.show();
        setTimeout(function () {
            // We got user data from request
            var user = {
                firstName: 'Vladimir',
                lastName: 'Kharlampidi',
                about: 'Hello, i am creator of Framework7! Hope you like it!',
                links: [
                    {
                        title: 'Framework7 Website',
                        url: 'http://framework7.io',
                    },
                    {
                        title: 'Framework7 Forum',
                        url: 'http://forum.framework7.io',
                    },
                ],
            };
            // Hide Preloader
            app.f7.preloader.hide();
        }, 3000);
    },
};

export default actions;
